module.exports = __webpack_public_path__ + "img/small-scorchmark.f4fb281f.png";